import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GradientIcon(props: IconProps) {
    return <Icon {...props} iconKey={"gradient"}/>
}
